import { useApiCreate } from '../../../../../lib/HttpService';
import { PATH } from './const';
import { StubbornDatasource } from '../../../../../application/business/StubbornAsset';

export const useEditionDatasourceCreate = () => useApiCreate<StubbornDatasource>(PATH);
